import React from 'react';
import Pro01 from "../../images/services/mvp/Seasoned-Tech-Leaders-For-IoT-Development.webp";
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Thinking ">
                            <h2>Forward-Thinking Digital Product Development</h2>
                        </div>
                        <p>We develop technology solutions and devise strategies that fuel growth for businesses that require utmost concentration and unwavering skills. With our experience and knowledge of how businesses function and how they are evolving in the modern world, you have the chance to make yours go big. Our strategic & technology consulting solutions help you bring your ideas to life.
                        </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">26+<span>projects completed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">32+<span>businesses served</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">8+<span>industries covered</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;